// CAROUSEL ITEM Info component

export const itemInfoTemplate = (labelTemplate, newsTitle) =>`
<div class="item-info">        
    ${labelTemplate}
    <h3 class="title">${newsTitle}</h3>
</div>`;


